/**
 * Injects FAQPage JSON-LD from article RTE: first h2 whose text starts with "FAQ",
 * then each h4 + following blocks until the next h2/h4 (paragraphs, lists, blockquotes).
 * Skips when article.metafields.custom.faq_schema already rendered (no script tag / metafield handled in Liquid).
 */
(function () {
  function text(el) {
    return (el && el.innerText ? el.innerText : '').replace(/\s+/g, ' ').trim();
  }

  function collectPairs(rte) {
    var h2s = rte.querySelectorAll('h2');
    var faqStart = null;
    for (var i = 0; i < h2s.length; i++) {
      var t = text(h2s[i]);
      if (/^faq\b/i.test(t)) {
        faqStart = h2s[i];
        break;
      }
    }
    if (!faqStart) return [];

    var items = [];
    var n = faqStart.nextElementSibling;
    while (n) {
      if (n.tagName === 'H2') break;
      if (n.tagName === 'H4') {
        var q = text(n);
        var parts = [];
        var s = n.nextElementSibling;
        while (s && s.tagName !== 'H2' && s.tagName !== 'H4') {
          if (
            s.matches &&
            s.matches('p, ul, ol, blockquote, div, h3')
          ) {
            parts.push(text(s));
          }
          s = s.nextElementSibling;
        }
        var a = parts.join(' ').replace(/\s+/g, ' ').trim();
        if (q && a) items.push({ q: q, a: a });
        n = s;
      } else {
        n = n.nextElementSibling;
      }
    }
    return items;
  }

  function inject(items) {
    if (!items.length) return;
    var el = document.createElement('script');
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: items.map(function (item) {
        return {
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.a,
          },
        };
      }),
    });
    document.head.appendChild(el);
  }

  function run() {
    var rte = document.querySelector('.article-template .article-template-content__rte.rte');
    if (!rte) return;
    inject(collectPairs(rte));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
